<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense>
      <v-col cols="12" sm="12" md="6" v-if="user.tipo === 'ADMIN'">
        <v-select
          outlined dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaProfessores(empresaSelecionada)"
          hide-details
        ></v-select>
      </v-col>

      <v-col cols="12" sm="12" md="6" v-if="professores.length">
        <v-autocomplete
          outlined
          dense
          v-model="professorSelecionado"
          :items="professores"
          item-text="nome"
          item-value="id"
          label="Selecione o professor"
          hide-details
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" lg="2">
        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y>
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedInicio"
              label="Data Início"
              append-icon="event"
              @blur="dataInicio = parseDate(dateFormattedInicio)"
              v-on="on"
              outlined 
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataInicio" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" lg="1">
        <v-text-field
          v-model="horaInicio"
          label="Hora Início"
          type="time"
          outlined 
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" lg="2">
        <v-menu 
          ref="menu2" 
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedFim"
              label="Data Fim"
              append-icon="event"
              @blur="dataFim = parseDate(dateFormattedFim)"
              v-on="on"
              outlined 
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataFim" no-title @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" lg="1">
        <v-text-field
          v-model="horaFim"
          label="Hora Fim"
          type="time"
          outlined 
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" lg="1">
        <v-btn dark fab small color="#01579B" @click="carregaServicesProfessor(empresaSelecionada || companyobj.id)">
          <v-icon>search</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="totalHorasTrabalhadas">
      <v-col cols="12">
        <v-alert type="info" border="left" colored-border class="mt-4">
          Total de horas trabalhadas no período:
          <strong>{{ totalHorasTrabalhadas }}</strong>
        </v-alert>
      </v-col>
    </v-row>

    <v-data-table
      :search="tabela.busca"
      :headers="tabela.cabecalho"
      :items="tabela.conteudo"
      class="elevation-1"
      style="border-radius: 10px;"
      :loading="tabela.carregamento"
      loading-text="Aguarde, buscando registros..."
    >
      <template v-slot:[`item.professor.nome`]="{ item }">
        <v-chip :color="!item.logout ? 'success' : 'error'" v-if="item.professor.nome">{{ item.professor.nome }}</v-chip>
      </template>
      <template v-slot:[`item.login`]="{ item }">
        <p style="margin:0" v-if="item.login">{{ formatDateHour(item.login) }}</p>
      </template>
      <template v-slot:[`item.logout`]="{ item }">
        <p style="margin:0" v-if="item.logout">{{ formatDateHour(item.logout) }}</p>
      </template>
      <template v-slot:[`item.created`]="{ item }">
        <p style="margin:0" v-if="item.logout">{{ calculaTempoTreino(item.login, item.logout) }}</p>
        <p style="margin:0; color:#aaa" v-else>Em treino</p>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="efetuarLogout(item)" :disabled="Boolean(item.logout)">
              <v-icon color="error">mdi-logout-variant</v-icon>
            </v-btn>
          </template>
          <span>Efetuar logout</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <Snackbar ref="chamaSnackbar" />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage" />
  </v-container>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global';
  import Snackbar from '../componentes/snackbar.vue';
  import axios from 'axios';
  import { mapState } from 'vuex';
  import moment from 'moment';

  export default {
    components: { Snackbar, Loading },
    data: vm => ({
      isLoading: false,
      fullPage: true,
      empresas: [],
      empresaSelecionada: '',
      professores: [],
      professorSelecionado: '',
      tabela: {
        cabecalho: [
          { text: 'Professor(a)', value: 'professor.nome', align: 'start' },
          { text: 'Entrada', value: 'login' },
          { text: 'Saída', value: 'logout' },
          { text: 'Tempo de aula', value: 'created' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        conteudo: [],
        busca: '',
        carregamento: false,
      },
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatDate(new Date().toISOString().substr(0,10)),
      dateFormattedFim: vm.formatDate(new Date().toISOString().substr(0,10)),
      dataInicio: new Date().toISOString().substr(0,10),
      dataFim: new Date().toISOString().substr(0,10),
      horaInicio: '00:00',
      horaFim: '23:59',
      totalHorasTrabalhadas: '',
    }),
  
    computed: mapState({
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),
  
    watch: {
      dataInicio(val) {
        this.dateFormattedInicio = this.formatDate(val);
      },

      dataFim(val) {
        this.dateFormattedFim = this.formatDate(val);
      }
    },

    mounted() {
      if (this.user.tipo === 'ADMIN') {
        this.carregaEmpresas();
      } else {
        const id = this.companyobj.id;
        this.carregaProfessores(id);
        this.carregaServicesProfessor(id);
      }
    },
  
    methods: {
      onEmpresaChange(id) {
        this.carregaProfessores(id);
        this.carregaServicesProfessor(id);
      },
      async carregaEmpresas() {
        const resp = await axios.get(`${baseApiUrl}Empresas?filter={"order":"nome ASC","fields":{"nome":true,"id":true}}&access_token=${sessionStorage.getItem('accToken')}`);
        this.empresas = resp.data;
      },
      async carregaProfessores(empresaId) {
        const resp = await axios.get(`${baseApiUrl}Professores?filter={"where":{"empresaId":"${empresaId}"}}&access_token=${sessionStorage.getItem('accToken')}`);
        this.professores = resp.data;
      },
      async carregaServicesProfessor(id) {
        this.tabela.carregamento = true;
        this.tabela.conteudo = [];
        this.totalHorasTrabalhadas = '';
        const where = {
          and: [
            { empresaId: id },
            { login: { gt: `${this.dataInicio}T${this.horaInicio}:00.000Z` } },
            { login: { lt: `${this.dataFim}T${this.horaFim}:00.000Z` } }
          ]
        };
        if (this.professorSelecionado) where.and.push({ professorId: this.professorSelecionado });
        const filter = encodeURIComponent(JSON.stringify({ where, include: ['professor'] }));
        try {
          const resp = await axios.get(`${baseApiUrl}ServiceProfessores?filter=${filter}&access_token=${sessionStorage.getItem('accToken')}`);
          this.tabela.conteudo = resp.data.sort(this.compareLogout);
          let totalSec = 0;
          resp.data.forEach(i => {
            if (i.login && i.logout) totalSec += moment.utc(i.logout).diff(moment.utc(i.login), 'seconds');
          });
          const h = Math.floor(totalSec/3600),
                m = Math.floor((totalSec%3600)/60),
                s = totalSec % 60;
          this.totalHorasTrabalhadas = `${h.toString().padStart(2,'0')}:${m.toString().padStart(2,'0')}:${s.toString().padStart(2,'0')}`;
        } catch {
          this.$refs.chamaSnackbar.open('Erro ao buscar registros','error');
        } finally {
          this.tabela.carregamento = false;
        }
      },
      formatDate(date) {
        if (!date) return null;
        const [y,m,d] = date.split('-');
        return `${d}/${m}/${y}`;
      },
      parseDate(str) {
        if (!str) return null;
        const [d,m,y] = str.split('/');
        return `${y}-${m.padStart(2,'0')}-${d.padStart(2,'0')}`;
      },
      compareLogout(a,b) {
        if (!a.logout && b.logout) return -1;
        if (a.logout && !b.logout) return 1;
        return 0;
      },
      formatDateHour(dt) {
        if (!dt) return '';
        const d = dt.substr(0,10).split('-').reverse().join('/');
        const t = dt.substr(11,8);
        return `${d} às ${t}`;
      },
      calculaTempoTreino(lg,lo) {
        if (!lg||!lo) return '';
        const d1 = moment.utc(lg), d2 = moment.utc(lo), diff = moment.duration(d2.diff(d1));
        return `${diff.hours().toString().padStart(2,'0')}:${diff.minutes().toString().padStart(2,'0')}:${diff.seconds().toString().padStart(2,'0')}`;
      },
      async efetuarLogout(item) {
        if (confirm(`Deseja efetuar logout para ${item.professor.nome}?`)) {
          await axios.post(`${baseApiUrl}ServiceProfessores/realizaLogout`,{professorId:item.professorId,deslogarAlunos:true});
        this.carregaServicesProfessor(this.empresaSelecionada || this.companyobj.id);
      }
    },
  },
}
</script> 

<style>
 .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }
</style>
